module.exports = __webpack_public_path__ + "img/NEW_Energie_Logo_RBG_2023.30f62418.svg";